import createDelegationHelpComponent from './createDelegationHelp.component';

let createDelegationHelpModule = angular.module('vacations-absences.createDelegationHelp', [])

.component('createDelegationHelp', createDelegationHelpComponent)

.name;

export default createDelegationHelpModule;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCreateDelegation/createDelegationHelp/createDelegationHelp.js